module.exports = __webpack_public_path__ + "img/eosc-synergy.48f07816.png";